export const config = {
    API_URL: process.env.REACT_APP_API_URL,
    SERVER_URL: process.env.REACT_APP_SERVER_URL,
    APP_URL: process.env.REACT_APP_URL,
}